<template>
  <div style="margin-top: 2rem;">
    <el-form ref="form" :model="form" :rules="rules" label-width="150px">
      <el-form-item label="企业名称" prop="firmName">
        <el-input v-model="form.firmName" placeholder="请输入单位名称" disabled />
      </el-form-item>
      <el-form-item label="联系人" prop="linkUser">
        <el-input v-model="form.linkUser" placeholder="请输入联系人" />
      </el-form-item>
      <el-form-item label="联系方式" prop="linkWay">
        <el-input v-model="form.linkWay" placeholder="请输入联系方式" />
      </el-form-item>
      <el-form-item label="供需类型" prop="gxType">
        <el-select v-model="form.gxType" placeholder="请选择供需类型" style="width: 100%">
          <el-option label="供应" value="0"></el-option>
          <el-option label="需求" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布人类别" prop="fbUserTag">
        <el-select v-model="form.fbUserTag" placeholder="请选择发布人类别" style="width: 100%">
          <el-option label="市场主体" value="0"></el-option>
          <el-option label="院校" value="1"></el-option>
          <el-option label="检验检测认证机构" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供需类别标签" prop="tagList">
        <el-select v-model="form.tagList" placeholder="请选择供需类别标签" style="width: 100%" multiple >
          <el-option
              v-for="(item,index) in tagList1"
              :key="index"
              :label="item.label"
              :value="item.tagId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供需内容" prop="supplyContent">
        <el-input type="textarea" v-model="form.supplyContent" maxlength="60" show-word-limit placeholder="请输入供需内容" />
      </el-form-item>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </el-form>
  </div>
</template>
<script>
import {postMobileApi, postSupplyDemand} from "../../api/zljc/fbgx";

export default {
  name: "fbgx",
  data(){
    return {
      // 供需类别标签列表
      tagList1: [],
      // 表单参数
      form: {
        firmName: undefined,
        linkUser: undefined,
        linkWay: undefined,
        supplyContent: undefined,
        gxType: undefined,
        tagList: undefined,
        fbUserTag: undefined,
      },
      // 表单校验
      rules: {
        firmName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
          {max: 60, message: '企业名称不能超过60个字符', trigger: 'blur'}
        ],
        linkUser: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
          {max: 60, message: '联系人不能超过60个字符', trigger: 'blur'}
        ],
        linkWay: [
          {required: true, message: '请输入联系方式', trigger: 'blur'},
          {max: 60, message: '联系方式不能超过60个字符', trigger: 'blur'}
        ],
        gxType: [
          {required: true, message: '请选择供需类型', trigger: 'blur'}
        ],
        fbUserTag: [
            {required: true, message: '请选择发布人类别', trigger: 'blur'}
        ],
        tagList: [
            {required: true, message: '请选择供需类别标签', trigger: 'blur'}
        ],
        supplyContent: [
          {required: true, message: '请输入供需内容', trigger: 'blur'},
          {max: 60, message: '供需内容不能超过60个字符', trigger: 'blur'}
        ],
      },
    }
  },
  created() {
    this.gettagList();
    this.loginUser();
  },
  methods: {
    loginUser(){
      //----【】需要修改为recid
      let ssessionLoginUser = {"token":"8c0ea4d4dc7a681ec6e9c068f92729ed","loginTime":1743064817710,"expireTime":1743066617710,"ipaddr":null,"loginLocation":null,"browser":null,"os":null,"permissions":null,"user":{"uuid":"142767912","realName":"孙平","isauthuser":"1","cartType":"111","cartId":"370633197012261327","tel":"13001658539","ftype":"2","corname":"威海顺通会计服务有限公司","cornumber":"91371000MA95018D8K","state":0,"isBlackList":"N","isWhEnt":"Y","finishedInfo":"Y","county":"371020","countyCh":"高区","ywFwjgRecid":"7446522257fa445fb8d52fa7b93b1595"},"ywFwjg":{"recid":"7446522257fa445fb8d52fa7b93b1595","pripid":"3710000000220210924BTTFG","name":"威海顺通会计服务有限公司","uniscid":"91371000MA95018D8K","dom":"乳山市大孤山镇吴家沟村","llr":"李四666","llrtel":"15311432453","llrphone":"86237928","type":"00350087310f439daa96aa3025a6c06d","fwlmStatus":"1","shStatus":"2","zcTime":null,"deleteStatus":"N","synopsis":"asdfdsaf","website":null,"createBy":null,"createTime":"2021-11-20 00:00:00","updateBy":"孔霞","updateTime":"2023-02-09 00:00:00","zcsjStartTime":null,"zcsjEntTime":null,"cxReason":null,"userType":"2","loginName":"威海顺通会计服务有限公司","uuid":"142767912","lastLoginTime":null,"isBlack":"N","loginStatus":"1","loginTime":1743064817759,"county":"371020","countyCh":"高区","deptId":51,"deptCode":"37100031","cardType":null,"cardNumber":null,"entcat":"1","isFinishEdInfo":null,"opIdea":null,"ywAuditStatus":"4","ywSaveStatus":"Y","ywDelStatus":"N"},"enabled":true,"islogin":true}
      // let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
      this.form.firmName = ssessionLoginUser.ywFwjg.name;
      this.form.linkUser = ssessionLoginUser.ywFwjg.llr;
      this.form.linkWay = ssessionLoginUser.ywFwjg.llrtel;
    },
    gettagList(){
      postMobileApi().then(res => {
        this.tagList1 = res.data
      })
    },
    submitForm(){
      this.$refs["form"].validate(valid => {
        if(valid){
          postSupplyDemand(this.form).then(res => {
            if(res.code == 200){
              this.form.supplyContent = undefined,
              this.form.gxType=undefined,
              this.form.tagList=undefined,
              this.form.fbUserTag=undefined,
              this.msgSuccess("提交成功");
          }})
        }
      })
    }
  }
}
</script>